import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled from 'styled-components';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 2px solid ", ";\n  max-width: 100%;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTHead = styled.thead(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey[5];
});

var TableHead = function TableHead(_ref) {
  var children = _ref.children,
      padding = _ref.padding,
      className = _ref.className;
  return React.createElement(StyledTHead, {
    padding: padding,
    className: className
  }, React.createElement("tr", null, children));
};

TableHead.defaultProps = {
  className: null,
  padding: null
};
TableHead.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableHead",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "padding": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The padding string to be applied to the TableRow."
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The children of the TableHead"
    }
  }
};
export default TableHead;
export { TableHead };